import * as Yup from 'yup'
import {BaseEntity} from '../../../shared/models/ApiModels'
import {TabOption} from '../../../shared/components/FormTabHeader'
import {ICustomerModel, initialCustomer} from './CustomerModel'

export interface ICorporateModel extends BaseEntity { 
  firstName: string
  lastName: string
  taxOffice?: string
  taxNumber?: string
  tcKimlikNo: number
  country?: string
  city?: string
  district: string
  gsm1: string
  gsm2?: string
  phone?: string
  emailAddress: string
  address: string
  description?: string

  firstOfficerPhone?: string
  firstOfficerEmail?: string
  secondOfficerPhone?: string
  secondOfficerEmail?: string
  thirdOfficerPhone?: string
  thirdOfficerEmail?: string

  corporateNumber?: string
  corporatePassword?: string
  specialCode?: string
  integrationCode?: string
  webDiscount?: string
  warningTime?: string
  operationBranch?: string
  balanceVisibleBranch?: string
  customerRepresentative: string
  bankInformation?: string
  warningMessage?: string

  tariff?: string
  maturityDay?: string
  invoiceAddressDifferent?: string
  hgsResponseType?: string
  licenseType?: string
  licenseCountry: string
  riskMessage?: string
  riskMessageDate?: string
  riskPermit?: string
  dealerCommissionRate?: string
  reservationSource?: string
  communicationLanguage?: string
  currency?: string
  invoicePeriod?: string
  customerClass: string
  customerType?: string
  stoppageType?: string
  stoppageCode?: string
  riskLimit?: string

  passive: boolean
  hideInvoiceDetail: boolean
  smsPermission: boolean
  mailPermission: boolean
  phonePermission: boolean
  birthdayTracking: boolean
  customerCardAnonymized: boolean
  rentalCardAnonymized: boolean
  reservationCardAnonymized: boolean
  invoiceCardAnonymized: boolean
  cashboxCardAnonymized: boolean
  trafficHgsCardAnonymized: boolean
  carNotAllowed: boolean
  ageLicenseFree: boolean
  showRenterOnInvoice: boolean
  branchSpecific: boolean
  hqCorporate: boolean
  brokerAgency: boolean
  findexRequired: boolean
}

export const initialCorporate: ICorporateModel = {
  customerType: 'CORPORATE',
  firstName: '',
  lastName: '',
  taxOffice: '',
  taxNumber: '',
  tcKimlikNo: undefined as unknown as number,
  country: '0',
  city: '',
  district: '',
  gsm1: '',
  gsm2: '',
  phone: '',
  emailAddress: '',
  address: '',
  description: '',

  firstOfficerPhone: '',
  firstOfficerEmail: '',
  secondOfficerPhone: '',
  secondOfficerEmail: '',
  thirdOfficerPhone: '',
  thirdOfficerEmail: '',

  corporateNumber: '',
  corporatePassword: '',
  specialCode: '',
  integrationCode: '',
  webDiscount: '',
  warningTime: '',
  operationBranch: '',
  balanceVisibleBranch: '',
  customerRepresentative: '',
  bankInformation: '',
  warningMessage: '',

  tariff: '',
  maturityDay: '',
  invoiceAddressDifferent: '',
  hgsResponseType: '',
  licenseType: '',
  licenseCountry: '',
  riskMessage: '',
  riskMessageDate: '',
  riskPermit: '',
  dealerCommissionRate: '',
  reservationSource: '',
  communicationLanguage: '',
  currency: '',
  invoicePeriod: '',
  customerClass: '', 
  stoppageType: '',
  stoppageCode: '',
  riskLimit: '',

  passive: false,
  hideInvoiceDetail: false,
  smsPermission: false,
  mailPermission: false,
  phonePermission: false,
  birthdayTracking: false,
  customerCardAnonymized: false,
  rentalCardAnonymized: false,
  reservationCardAnonymized: false,
  invoiceCardAnonymized: false,
  cashboxCardAnonymized: false,
  trafficHgsCardAnonymized: false,
  carNotAllowed: false,
  ageLicenseFree: false,
  showRenterOnInvoice: false,
  branchSpecific: false,
  hqCorporate: false,
  brokerAgency: false,
  findexRequired: false,
}

export const validationCorporate = Yup.object().shape({
  firstName: Yup.string().required('Firma adı zorunludur'), 
  emailAddress: Yup.string().email('Geçerli bir e-posta girin').required('E-posta zorunludur'),
  gsm1: Yup.string().required('GSM zorunludur'),
  address: Yup.string().required('Adres zorunludur'),
  tcKimlikNo: Yup.mixed().test('tc', 'TC Kimlik No 11 haneli olmalı', (value) => {
    const s = value === null || value === undefined ? '' : String(value)
    if (s === '' || s === '0') return true
    return /^[0-9]{11}$/.test(s)
  }),
  taxOffice: Yup.string().required('Vergi dairesi zorunludur'),
  taxNumber: Yup.string().required('Vergi numarası zorunludur'),
  firstOfficerPhone: Yup.string().required('Yetkili telefon numarası zorunludur'),
  firstOfficerEmail: Yup.string().email('Geçerli bir e-posta girin').required('Yetkili e-posta zorunludur'),
  secondOfficerEmail: Yup.string().email('Geçerli bir e-posta girin').nullable().notRequired(),
  thirdOfficerEmail: Yup.string().email('Geçerli bir e-posta girin').nullable().notRequired(),
})

export const corporateTabs: TabOption<'company' | 'detail' | 'permission'>[] = [
  {key: 'company', title: 'Firma Bilgileri', icon: 'bi bi-building'},
  {key: 'detail', title: 'Sözleşme & Detay', icon: 'bi bi-clipboard-data'},
  {key: 'permission', title: 'İzinler & Ayarlar', icon: 'bi bi-shield-check'},
]

/** API müşteri DTO’su; kurumsal formda olmayan alanlar initialCustomer’dan gelir */
export function corporateToCustomerPayload(values: ICorporateModel): ICustomerModel {
  return {
    ...initialCustomer,
    ...values,
  } as ICustomerModel
}
